import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  selector: "hint",
  templateUrl: "./hint.component.html",
  styleUrls: ["./hint.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HintComponent {}
